import { Button, Dialog, DialogContent, Stack, Typography } from '@mui/material';
import {
    adwUpdateSelectedFile,
    setIsRedirected,
    setSelectedFileGroups,
    setSelectedQueryTool
} from '../../dataWranglerSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useWizardQuery } from "../../../../api/dataWranglerApiSlice";
import { selectSelectedDatabase } from "../../../common/databaseSlice";
import { useUserInfoQuery } from "../../../../api/userApiSlice";

const ExceededDownloadLimitModal = ({ open, onClose, instruments }: any) => {
    const dispatch = useDispatch();
    const { data: userData } = useUserInfoQuery({});
    const selectedDatabase = useSelector(selectSelectedDatabase);
    const isGuestUser = userData?.id === -1
    const { data } = useWizardQuery({ database: selectedDatabase }, { skip: isGuestUser });

    const continueOnClick = () => {
        const tabular: string[] = [];
        const setGroups: {[key: string]: boolean} = {}
        const selectedFiles: {[key: string]: any} = {}
        data.files_tabular.forEach((file: any) => {
            if (instruments.includes(file.suffix)) {
                if (!selectedFiles[file.file_dataset]) {
                    selectedFiles[file.file_dataset] = {
                        files_tabular: {}
                    }
                }
                if (file.virtual_groups.length > 0 && !setGroups[file.virtual_groups[0]]) {
                    setGroups[file.virtual_groups[0]] = true;
                    tabular.push(`${file.file_dataset}_files_tabular__${file.virtual_groups[0]}`);
                }
                tabular.push(`${file.file_dataset}_files_tabular__${file.virtual_groups[0]}__${file.suffix}`)
                selectedFiles[file.file_dataset]["files_tabular"][`suffix::${file.suffix}`] = true
            }
        })
        dispatch(setIsRedirected(true));
        dispatch(setSelectedQueryTool("allStudyData"));
        dispatch(adwUpdateSelectedFile(selectedFiles));
        dispatch(setSelectedFileGroups(tabular));
    }
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogContent>
                <Stack gap={3} textAlign="center" justifyContent="center">
                    <Typography>
            You have exceeded the maximum limit of variables for a single CSV output. You have 2 choices,
            you can reduce the number of variables selected, or you can download entire instruments using
            the “Transfer Files” Mechanism, where your selections will be transferred to the location of
            your choice in BIDs format.
                    </Typography>
                    <Stack direction="row" gap={3} justifyContent="center">
                        <Button size="small" variant="secondary" onClick={onClose}>Reduce Instruments</Button>
                        <Button size="small" variant="primary" onClick={continueOnClick}>Go To Transfer File
              Page</Button>
                    </Stack>
                </Stack>
            </DialogContent>
        </Dialog>
    )
}

export default ExceededDownloadLimitModal;
